import React from 'react';
import logger from '../services/logger';

/**
 * The `useDeviceDetect` function is a custom React hook that detects the user's device type (mobile or
 * not) and returns the result as a boolean value.
 * @returns The function `useDeviceDetect` returns an object with a property called `isMobile`. The
 * value of `isMobile` represents whether the user's device is a mobile device or not.
 */
export default function useDeviceDetect() {
  // /** The line `const [isMobile, setMobile] = React.useState(false);` is using the `useState` hook from
  //     React to create a state variable called `isMobile` and a corresponding function called `setMobile`
  //     to update its value. */
  // const [isMobile, setMobile] = React.useState(false);
  // const [isTablet, setTablet] = React.useState(false);

  // /** The `React.useEffect` hook is used to perform side effects in functional components. In this case,
  //      it is used to detect the user's device type (mobile or not) and update the `isMobile` state
  //     variable accordingly. */
  // React.useEffect(() => {
  //   const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
  //   // const mobile = Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));
  //   const mobile = Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPod|Opera Mini|IEMobile|WPDesktop/i));
  //   setMobile(mobile);
  //   const tablet = Boolean(userAgent.match(/iPad|Tablet/i));
  //   setTablet(tablet);

  // }, []);

  const [deviceType, setDeviceType] = React.useState('');
  React.useEffect(() => {
    function handleResize() {
      const viewportWidth = window.innerWidth;
      logger.info('viewportWidth =====>>>> ', viewportWidth);
      if (viewportWidth < 768) {
        setDeviceType('MOBILE');
      } else if (viewportWidth >= 768 && viewportWidth <= 1024) {
        setDeviceType('TABLET');
      } else {
        setDeviceType('DESKTOP');
      }
    }

    // Initial check on component mount
    handleResize();
    // Add event listener to track viewport width changes
    window.addEventListener('resize', handleResize);
    // Remove event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return deviceType;
}
